import "../../../css/modules/personnalisation/common.scss";

export default class customizationFrontCommon {

    constructor(Parent) {
        this.dataParent = Parent;
    }

    init() {
        console.log('init Common');

        const dataParent = this.dataParent;
        $("#load-template").on("click", ".presentProduct", function () {
            dataParent.class.Dom.clickVariationProduct($(this));
        });

        $("#load-template").on("click", "#ia", function () {
            dataParent.class.Dom.clickIAPopup($(this));
        });

        $("#content").on("click", "#ia-close", function () {
            console.log('click close');
            $('#ia-modal').modal('hide');
        });

        $("#content").on("click", "#ia-create", function () {
            dataParent.class.Dom.clickIACreate($(this));
        });


        $("#AttributesLoadedModal").on("click", ".customModify", function (e) {
            e.preventDefault();
            dataParent.class.Dom.clickCustomModify($(this));
        });

        $("#AttributesLoadedModal").on("click", ".addForeignProduct", function (e) {
            e.preventDefault();
            dataParent.class.Dom.clickaddForeignProduct($(this));
        });


        $("#load-template").on("change", "#imageLoader_1, #imageLoader_2,#imageLoader_3, #imageLoader_4,#imageLoader_5", function () {
            dataParent.class.Dom.imageUploader($(this).attr('id'));
        });
    }
}
